<template>
  <div class="product">
    <div class="ub">
      <div class="img-box">
        <img :src="item.attachUrl || item.attachPath" alt />
      </div>
      <div class="info">
        <h1 @click="toDeviceDetail(item)">
          {{ item.bodyNum }}
          <span>{{ item.productCode }}</span>
        </h1>
        <div class="about ub">
          <div class="ub ub-xc">
            <i class="icon icon-battery-percent-75"></i>
            <span>{{ item.batteryCharge ? item.batteryCharge + '%' : '--' }}</span>
          </div>
          <div class="ub ub-xc">
            <i :class="['icon', item.networkType === 1 || item.networkType === '1' ? 'icon-wifi' : 'icon-xinhao']"></i>
            <span>{{ _this.getDicValue('dms_device_cellular_mode', item.cellularMode) || '--' }}</span>
          </div>
          <div class="ub ub-xc">
            <i class="icon icon-temperature"></i>
            <span>{{ item.batteryTemp ? _this.$celsiusToFahrenheit(item.batteryTemp) + _this.$formatTempUnit() : '--' }}</span>
          </div>
          <div v-if="item.isMalfunction" class="err"><i class="icon icon-jinggao"></i></div>
          <div v-if="item.isPowerSave && !item.isMalfunction" class="eco"><i class="icon icon-eco"></i></div>
          <div v-if="item.lockState" class="lock"><i class="icon icon-lock"></i></div>
        </div>
      </div>
    </div>
    <div class="ub loc-wrap">
      <div class="location">
        <div>{{ item.location }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoWindowContent',
  props: {
    item: {
      type: Object,
      required: true,
    },
    toDeviceDetail: Function,
    _this: Object
  },
  methods: {
  },
};
</script>
